import { BaseService, Service } from "/@/cool";
@Service("shop")
class Shop extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["infoLabelStatus"] = prefix + "infoLabelStatus";
	}

	//获取门店是否开启了 订单标签和样品标签的功能
	infoLabelStatus(data: any) {
		return this.request({
			url: "/infoLabelStatus",
			method: "POST",
			data
		});
	}
}
export default Shop;
